import { Shield, TrendingUp, Clock, MessageSquare } from "lucide-react";

const trustReasons = [
  {
    id: "honesty",
    icon: Shield,
    title: "No BS Honesty",
    description: "I tell you exactly what you need to hear, not what you want to hear. Your success is my priority.",
  },
  {
    id: "track-record",
    icon: TrendingUp,
    title: "150+ Homes Sold",
    description: "A proven track record of results across Southern California. Experience you can count on.",
  },
  {
    id: "experience",
    icon: Clock,
    title: "15 Years Experience",
    description: "Since 2011, I've navigated every market condition. I know how to win in any situation.",
  },
  {
    id: "available",
    icon: MessageSquare,
    title: "Always Available",
    description: "I actually answer my phone. Real communication, real responsiveness, real results.",
  },
];

export default function TrustReasons() {
  return (
    <section className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight uppercase text-white">
            Why Work <span className="text-[#D4AF37]">With Me</span>
          </h2>
          <p className="text-zinc-400 max-w-2xl mx-auto">
            I do what I say and say what I mean. Here's what sets me apart.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustReasons.map((reason) => (
            <div
              key={reason.id}
              className="card-dark p-8 space-y-4 hover:border-[#D4AF37]/50 transition-all duration-300 animate-fadeInUp"
              data-testid={`trust-reason-${reason.id}`}
            >
              <div className="w-14 h-14 bg-[#D4AF37] flex items-center justify-center">
                <reason.icon className="w-7 h-7 text-black" />
              </div>
              <h3 className="text-xl font-bold text-white">{reason.title}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
